import styled from 'styled-components'

import RowGroup from '../RowGroup'
import { breakpoint } from 'utils'

export const BillingRow = styled(RowGroup.Row)`
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  padding-top: 4;
  padding-bottom: 4;
  position: relative;

  flex-direction: column;
  ${breakpoint('xs')`
    flex-direction: row
  `};
`

export const BillingHeadingCell = styled(RowGroup.HeadingCell).attrs({
  width: ['100%', 1 / 4],
})``

export const BillingDescriptionCell = styled(RowGroup.CaptionCell).attrs({
  width: ['100%', 1 / 4],
})`
  flex: 1;
`

export const BillingDownloadCell = styled(RowGroup.CaptionCell).attrs({
  textAlign: ['left', 'right'],
  mt: [4, 0],
  width: ['100%', 140],
})``

export const Description = styled.div`
  word-wrap: break-word;
`

export const DiscountCode = styled.strong`
  color: ${({ theme }) => theme.colors.green};
`
